export const USER_SET = 'USER/SET';
export const ISLOADING_SET = 'ISLOADING/SET';
export const ISREGISTER_SET = 'ISREGISTER/SET';
export const ISLOGIN_SET = 'ISLOGIN/SET';
export const MESSAGES_SET = 'MESSAGES/SET';
export const CHATWITH_SET = 'CHATWITH/SET';
export const PRODUCTS_SET = 'PRODUCTS/SET';
export const PRODUCT_SET = 'PRODUCT/SET';
export const CART_SET = 'CART/SET';
export const HISTORY_SET = 'HISTORY/SET';
export const CHATLIST_SET = 'CHATLIST/SET';
export const SELLER_PRODUCTS_SET = 'SELLER/PRODUCTS/SET';
export const SELLER_PRODUCT_DETAIL_SET = 'SELLER/PRODUCT/DETAIL/SET';
